import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Menu } from '@dropbox/dig-components/menu';

import HfReactHelper from 'js/sign-components/common/hf-react-helper';
import { getBrandName } from 'js/sign-components/common/brand';
import type { PropsWithSiteCode } from 'js/sign-components/common/brand';

export function ProductsMenuContent({ siteCode }: PropsWithSiteCode) {
  const site = HfReactHelper.HfSites.getSite(siteCode);
  const isSign = HfReactHelper.HfSites.isHelloSign(site);
  const isFax = HfReactHelper.HfSites.isHelloFax(site);

  return (
    <>
      <Menu.Segment
        {...(isSign
          ? {
              withLabel: (
                <FormattedMessage
                  id=""
                  description="Heading for a list of products owned by us."
                  defaultMessage="Our products"
                />
              ),
            }
          : {})}
      >
        {isFax && (
          <Menu.LinkItem
            data-qa-ref="global-nav-esign-product-link"
            href={HfReactHelper.urlHelper(
              'home/bridge/to/S',
              HfReactHelper.HfSites.SITE_CODE_HF,
            )}
            target="_blank"
          >
            {getBrandName('S')}
          </Menu.LinkItem>
        )}
        <Menu.LinkItem
          data-qa-ref="global-nav-esign-api-product-link"
          href={HfReactHelper.getWebflowUrl('products/api')}
          target="_blank"
        >
          <FormattedMessage
            id=""
            description="A link which redirects the user to the API page for the given product. Ex. 'Acme API'"
            defaultMessage="{productName} API"
            values={{ productName: getBrandName('S') }}
          />
        </Menu.LinkItem>
        {isSign && (
          <Menu.LinkItem
            data-qa-ref="global-nav-fax-product-link"
            href={HfReactHelper.urlHelper(
              'home/bridge/to/F',
              HfReactHelper.HfSites.SITE_CODE_HS,
            )}
            target="_blank"
          >
            {getBrandName('F')}
          </Menu.LinkItem>
        )}
      </Menu.Segment>
      {isSign && (
        <Menu.Segment
          withLabel={
            <FormattedMessage
              id=""
              description="Heading for a list of integrations available for our product."
              defaultMessage="Integrations"
            />
          }
        >
          <Menu.LinkItem
            data-qa-ref="global-nav-gdocs-integration-link"
            href={HfReactHelper.getWebflowUrl('integrations/google-docs')}
            target="_blank"
          >
            <FormattedMessage
              id=""
              description="A link which redirects the user to Google Docs integration page."
              defaultMessage="Google Docs"
            />
          </Menu.LinkItem>
          <Menu.LinkItem
            data-qa-ref="global-nav-gdrive-integration-link"
            href={HfReactHelper.getWebflowUrl('integrations/google-drive')}
            target="_blank"
          >
            <FormattedMessage
              id=""
              description="A link which redirects the user to Google Drive integration page."
              defaultMessage="Google Drive"
            />
          </Menu.LinkItem>
        </Menu.Segment>
      )}
    </>
  );
}
